define('components/videofactory/models/MMMVideoModel', function() {

    var MMMVideoModel = Backbone.Model.extend({
        defaults: {
            viewId: "mmm-video-Id", // Classic default viewId
            id: null, //ID use in DOM and MMM init function
            mmmID: null, //MMM ID for video
            muted: false,
            autoplay: false,
            poster: null, //Url of poster image
            subtitlesOn: false, //Subtitles status
            subtitle: null, //Url of subtitles file
            share: false, //TODO: To dev, not working today
            locale: { //Wording use on Player
                fullscreen: '',
                volume: '',
                share: '',
                subtitles: ''
            },
            videoWidth: '100%', // Width of video (could be in % or px)
            videoHeight: '100%', // Height of video (could be in % or px)
            currentTime: -1, // Current time of the video (in milliseconds)
            duration: -1, // Duration of the video (in milliseconds)
            onReady: null, // Callback when video is ready
            onPlay: null, // Callback when video is played
            onPause: null, // Callback when video is paused
            onEnded: null, // Callback when video is ended
            onFullscreenChange: null, // Callback when fullscreen state change,
            logoDiorTV: false
        }
    });

    return MMMVideoModel;
});